import React, { CSSProperties } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

interface CreateButtonProps {
    color: string;
    onClick?: () => void;
    iconOnly?: boolean;
    label?: string;
    className?: string;
    style?: CSSProperties;
}

const CreateButton: React.FC<CreateButtonProps> = ({ color, onClick, iconOnly = false, label = 'Vytvoriť', className, style: userStyle = {} }) => (
    <button
        type="button"
        onClick={onClick}
        className={`st-btn st-btn--fill${iconOnly ? ' st-btn--icon' : ''}${className ? ` ${className}` : ''}`}
        style={{ '--btn-accent': color, ...userStyle } as CSSProperties}
    >
        <FontAwesomeIcon icon={faPlus} />
        {!iconOnly && <span>{label}</span>}
    </button>
);

export default CreateButton;
